@if (loading$ | async) {
  <div>
    <kb-loader></kb-loader>
  </div>
}

<cx-storefront></cx-storefront>
<ng-template [cxOutletRef]="'ProductListPageTemplate'" [cxOutletPos]="before" true>
  @if (categoryModel?.['subCategories']) {
    <div class="category-page-left-heading-background">
    </div>
  }
  @if (categoryModel?.['subCategories']) {
    <h1 class="category-page-left-heading m-0">
      <span>{{ categoryModel?.['categoryName'] }}</span>
    </h1>
  }
</ng-template>
<ng-template [cxOutletRef]="'Section5'" [cxOutletPos]="before" true>
  <div class="outer">
    <div class="category-header">
      {{'common.homepage_proeuct_categories'|cxTranslate}}
    </div>
  </div>
</ng-template>